const slidesByResolution = {
    0: [
        {
            "id": "paralax-bg-slide",
            "moveY": 20,
            "moveX": 20,
            "zoom": 0
        },
        {
            "id": "paralax-lower-city",
            "moveY": 10,
            "moveX": -80,
            "zoom": 80
        },
        {
            "id": "paralax-clinic",
            "moveY": 0,
            "moveX": -120,
            "zoom": 250
        },
        {
            "id": "paralax-plants",
            "moveY": -5,
            "moveX": -10,
            "zoom": 35
        }
    ],
    800: [
        {
            "id": "paralax-bg-slide",
            "moveY": 140,
            "moveX": 10,
            "zoom": 0
        },
        {
            "id": "paralax-lower-city",
            "moveY": 30,
            "moveX": -3,
            "zoom": 30
        },
        {
            "id": "paralax-clinic",
            "moveY": 0,
            "moveX": -15,
            "zoom": 70
        },
        {
            "id": "paralax-plants",
            "moveY": -20,
            "moveX": -10,
            "zoom": 35
        }
    ]
};
let previousScroll = 0;
let slowScrollEnabled = true;
function slowDownScroll() {
    const currentScroll = window.scrollY;
    const pageScrollPercentage = Math.min(1, Math.max(0, currentScroll / window.innerHeight));
    if (pageScrollPercentage < 1 && slowScrollEnabled) {
        const pageScrollReversedPercentage = 1 - pageScrollPercentage;
        const scrollSpeedRatio = 1 + 4 * pageScrollReversedPercentage;
        const scrollDiff = currentScroll - previousScroll;
        const targetScroll = previousScroll + scrollDiff / scrollSpeedRatio;
        window.scrollTo(window.scrollX, targetScroll);
    } else slowScrollEnabled = false;
    if (!slowScrollEnabled && pageScrollPercentage == 0) slowScrollEnabled = true;
    previousScroll = window.scrollY;
}
function customScrollIntoView(elementId) {
    const element = document.getElementById(elementId);
    if (!element) return;
    slowScrollEnabled = false;
    element.scrollIntoView({
        behavior: 'smooth'
    });
}
function customScrollTop() {
    slowScrollEnabled = false;
    window.scrollTo({
        top: 0,
        behavior: 'smooth'
    });
}
function adjustBanner() {
    const banner = document.getElementById("paralax-banner");
    if (!banner) return;
    const bannerRect = banner.getBoundingClientRect();
    const bannerTop = bannerRect.top;
    const bannerHeight = bannerRect.height;
    const bannerScrollPx = Math.max(0, -bannerTop);
    const bannerScrollPercent = Math.min(1, bannerScrollPx / bannerHeight);
    const screenWidth = window.screen.width;
    const keyForResolution = Math.max(...Object.keys(slidesByResolution).filter((e)=>e < screenWidth));
    const slides = slidesByResolution[keyForResolution];
    for (const slide of slides){
        const element = document.getElementById(slide.id);
        const elementImg = element.querySelector('img');
        if (slide.moveY) elementImg.style.top = bannerScrollPercent * slide.moveY + 'vh';
        if (slide.moveX) elementImg.style.left = bannerScrollPercent * slide.moveX + 'vw';
        if (slide.zoom) elementImg.style.width = 100 + bannerScrollPercent * slide.zoom + '%';
    }
    if (bannerScrollPercent === 1) {
        const scrollRange = 30;
        const topBarOpacity = Math.min(bannerScrollPx - bannerHeight, scrollRange) / scrollRange;
        document.getElementById("top-bar").style.position = 'fixed';
        document.getElementById("top-bar").style.opacity = topBarOpacity;
    } else {
        document.getElementById("top-bar").style.position = '';
        document.getElementById("top-bar").style.opacity = 1;
    }
}
document.addEventListener("DOMContentLoaded", adjustBanner);
addEventListener("resize", adjustBanner);
addEventListener("scroll", adjustBanner);

//# sourceMappingURL=landing.e3faf37e.js.map
